module.exports = __webpack_public_path__ + "img/mood.b01a07b8.jpg";